import { render, staticRenderFns } from "./WPCheckbox.vue?vue&type=template&id=3cf03349"
import script from "./WPCheckbox.vue?vue&type=script&lang=ts"
export * from "./WPCheckbox.vue?vue&type=script&lang=ts"
import style0 from "./WPCheckbox.vue?vue&type=style&index=0&id=3cf03349&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports